import React from 'react';
import { motion } from 'framer-motion';
import NotificationForm from './NotificationForm';

const PreFooter: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 md:px-12 lg:px-20">
        <motion.div 
          className="max-w-3xl mx-auto text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800">Be the first to know when we launch</h2>
          <p className="text-gray-600 mb-8 max-w-xl mx-auto">
            Join our notification list and be among the first to experience SokoVibe, 
            the premier Afro-Caribbean marketplace.
          </p>
          <NotificationForm className="max-w-lg mx-auto" />
        </motion.div>
      </div>
    </section>
  );
};

export default PreFooter;
